var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftBackgroundLines1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 261,
    viewBox: "0 0 112 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-28.9121 481.723L80.6018 214.058C84.1473 205.393 79.6409 199.669 70.7592 201.557L-20.1771 220.886C-28.6895 222.695 -33.2514 217.506 -30.3665 209.295L23.7478 55.2863C26.8251 46.5285 21.959 40.9934 12.8791 42.9234L-41.125 54.4024",
    stroke: "url(#paint0_linear_1238_92481)",
    strokeWidth: 0.525245
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M-61.6309 133.729L61.6731 107.52L-11.2832 315.154L111.764 288.999",
    stroke: "url(#paint1_linear_1238_92481)",
    strokeWidth: 0.525245
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1238_92481",
    x1: 18.9897,
    y1: 436.453,
    x2: -186.943,
    y2: 145.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375941,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727934,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1238_92481",
    x1: 41.0691,
    y1: 84.4508,
    x2: 74.7648,
    y2: 324.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBackgroundLines1);
export default __webpack_public_path__ + "static/media/left-backgroundLines1.953c5acd415c7167c5b5db96550db90e.svg";
export { ForwardRef as ReactComponent };